import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Material } from "../../materials/_types/material";

export class CaseServiceMaterial extends Resource {
    public override type = 'caseServiceMaterials';

    @prop()
    public caseServiceId!: string;

    @prop()
    public materialId!: string;

    public material?: Material;
}
